module.exports = __webpack_public_path__ + "img/storeFour.1eeabbe4.png";